import _ from "lodash";

export const generateFilter = (column: string, search: string) => ({
  column,
  operator: "ilike",
  value: `%${search}%`,
})
export const splitStringWithLimit = (str: string, delimiter: string, limit: number) => {
  const parts = str.split(delimiter);
  const result = _.slice(parts, 0, limit - 1);
  result.push(parts.slice(limit - 1).join(delimiter));
  return result;
}